import angular from 'angular';
import { MeurhFeriasService } from './ferias.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhFeriasListRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider) {
		const resolve = {
			'entity': [
				'MeurhFeriasService',
                'ListagemService',
                '$rootScope',
				'$stateParams',
				'$state',
				'$q',
				function (
					entityService: MeurhFeriasService,
                    listagemService: ListagemService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        liberadoTela: (arg: string) => boolean
                    },
					$stateParams: angular.ui.IStateParamsService,
					$state: angular.ui.IStateService,
					$q: angular.IQService
				) {
					if (!$stateParams['solicitacao']) {
						return $q<void>(() => $state.go('ferias_marcacoes'));
					}

					return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                            const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                            const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                            const deveRedirecionar = (
                                (visibilidadeLiberada && !empresaNoGrupo) ||
                                (!visibilidadeLiberada && !mesmoEstabelecimento)
                            );

                            if (deveRedirecionar) {
                                return $q(() => $state.go('ferias_marcacoes'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('ferias_marcacoes_not_found', $stateParams)) {
                                        $state.go('ferias_marcacoes_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
				}
			]
		};

		$stateProvider
			.state('ferias_marcacoes', {
				url: '/ferias/marcacoes?q',
				template: require('html-loader!./FeriasMarcacoes/index/feriasmarcacoes.index.html'),
				controller: 'Meurh\FeriasmarcacoesIndexController',
				controllerAs: 'mrh_frsmrcs_lst_cntrllr',
				reloadOnSearch: false
			})
			.state('ferias_marcacoes_show', {
				parent: 'ferias_marcacoes',
				url: '/:solicitacao?path',
				resolve,
				template: require('html-loader!./FeriasMarcacoes/show/feriasmarcacoes.show.html'),
				controller: 'Meurh\FeriasmarcacoesShowController',
				controllerAs: 'mrh_frsmrcs_shw_cntrllr',
			})
			.state('ferias_marcacoes_new', {
				parent: 'ferias_marcacoes',
				url: '/new',
				params: {
					trabalhador: {},
				},
				template: require('html-loader!./FeriasMarcacoes/new/feriasmarcacoes.new.html'),
				controller: 'Meurh\FeriasmarcacoesNewController',
				controllerAs: 'mrh_frsmrcs_nw_cntrllr',
			})
			.state('ferias_marcacoes_edit', {
				parent: 'ferias_marcacoes',
				url: '/:solicitacao/edit',
				resolve,
				template: require('html-loader!./FeriasMarcacoes/edit/feriasmarcacoes.edit.html'),
				controller: 'Meurh\FeriasmarcacoesEditController',
				controllerAs: 'mrh_frsmrcs_dt_cntrllr',
			})
			.state('ferias_marcar_em_grade', {
				url: '/ferias/marcaremgrade?q?situacao?estabelecimento',
				template: require('html-loader!./FeriasMarcarEmGrade/index/feriasmarcaremgrade.index.html'),
				controller: 'Meurh\FeriasmarcaremgradeIndexController',
				controllerAs: 'mrh_frsmrcrmgrd_lst_cntrllr',
				reloadOnSearch: false
			})
			.state('ferias_calendario_ferias', {
				url: '/ferias/calendarioferias?q?situacao?estabelecimento',
				template: require('html-loader!./CalendarioFerias/calendarioferias.index.html'),
				controller: 'Meurh\CalendarioFeriasController',
				controllerAs: 'mrh_clndr_frs_cntrllr',
				reloadOnSearch: false
			})
            .state('controleferias_relatorio', {
                url: '/ferias/controleferias?tipo',
                template: require('html-loader!./ControleFerias/controleferias.html'),
                controller: 'ControleFeriasController',
                controllerAs: 'cntrl_frs_ctrl',
                reloadOnSearch: false
            });
	}
];
